import script from "./pwaDownloadCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./pwaDownloadCard.vue?vue&type=script&lang=ts&setup=true"

import "./pwaDownloadCard.vue?vue&type=style&index=0&id=592d1c03&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592d1c03"]])

export default __exports__